import { createSlice } from "@reduxjs/toolkit";


const productSlice = createSlice({
    name: 'product',
    initialState: {
        productLocalization: {
            skuNumber: '',
            countryName: ''
        },
        traceInformation: {},
        mdmProductInformation: {
            product: {},
            mainInformations: {
                marketingCode: '',
                energyLabelIcon: '',
                productGroup: '',
                productImage: '',
                productImages: [],
                energyClasses: [],
            },
            productInfo: [],
            productGuides: [],
            technicalInformations: [],
        },
        mdmDataFetchingError: false,
        warrantyInfo: {
            fetchingError: false,
            data: {
                extendedWarranty: {},
                warranty: {}
            }
        },
        // null = product-details henüz layout bilgisini döndürmedi.
        uiLayoutType: null,
        isLoading: true,
        hubIsLoading : false,
        cirpassHistoryQueryParameters: null,
    },
    reducers: {
        setProductLocalization(state, action) {
            state.productLocalization = action.payload;
        },
        setUiLayoutType(state, action) {
            state.uiLayoutType = action.payload;
        },
        setTraceInformation(state, action) {
           state.traceInformation = action.payload;
        },
        setMdmProductInformation(state, action) {
            // Backend product-details yanıtındaki data.productDetail objesi bekleniyor.
            const payload = action.payload || {};
            const commons = payload.commons || [];

            state.mdmProductInformation.product = payload;

            state.mdmProductInformation.mainInformations.marketingCode =
                commons.find(x => x.description === "MarketingCode")?.value || '';

            state.mdmProductInformation.mainInformations.energyLabelIcon =
                commons.find(x => x.code === "A4983_51126718")?.value || '';

            state.mdmProductInformation.mainInformations.productGroup =
                payload.productGroupName || '';

            state.mdmProductInformation.mainInformations.productImage =
                commons.find(x => x.code === "F1752_54365")?.value || '';

            state.mdmProductInformation.mainInformations.productImages =
                commons.filter(x => x.fieldType === "product-image" && x.code !== "F1752_54365");

            state.mdmProductInformation.mainInformations.energyClasses =
                commons.filter(x => x.fieldType === "energy-class");

            state.mdmProductInformation.productInfo =
                commons.filter(x => x.fieldType === "long-product-info");

            state.mdmProductInformation.productGuides = payload.guides || [];

            state.mdmProductInformation.technicalInformations =
                commons.filter(x => x.fieldType === "technical-info");

            state.mdmProductInformation.dppQueryParameters = payload.dppQueryParameters || null;
        },
        setMdmDataFetchingError(state, action) {
            state.mdmDataFetchingError = action.payload;
        },
        setWarrantyInfo(state, action) {
            const { data, fetchingError } = action.payload;
            state.warrantyInfo.data.extendedWarranty = data.find(warranty => warranty.warrantyType === "Ek Garanti");
            state.warrantyInfo.data.warranty = data.find(warranty => warranty.warrantyType === "Garanti İçi");
            state.warrantyInfo.fetchingError = fetchingError;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setHubIsLoading(state,action) {
            state.hubIsLoading = action.payload;
        },
        setCirpassHistoryQueryParameters(state, action) {
            state.cirpassHistoryQueryParameters = action.payload;
        }
    }
})
export const productActions = productSlice.actions;
export default productSlice;